import clsx from 'clsx';

interface PlayerSingleStatProps {
  className?: string;
  statValue: number;
  isHome: boolean;
}

export default function PlayerSingleStat({
  className = '',
  statValue,
  isHome,
}: PlayerSingleStatProps) {
  return (
    <div
      className={clsx(
        'col-span-3',
        'flex',
        'items-center',
        'justify-center',
        'min-w-[60px]',
        'p-2',
        'rounded-xl',
        { 'bg-pmw-player-stat-home-bg': isHome, 'bg-pmw-player-stat-away-bg': !isHome },
        className,
      )}
    >
      <span className="font-unibet font-medium text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
        {statValue || '-'}
      </span>
    </div>
  );
}
